<!--
    描述：省市区 三联组件
    时间：2020-10-15
    Created by ws
-->
<template>
    <!-- <div class="">
        <address-form :showDetail="false"
							  ref="addressForm"
							  v-model="formValue"></address-form>
    </div> -->
    <div class="example-layout">
        <!-- 具体实例 -->
        <div class="example-box">
            <div class="example-title">
                展示省市区
            </div>
            <div class="example-content">
				<address-form ref="addressForm"
							  v-model="formValue"></address-form>
			</div>
        </div>

        <div class="example-box">
            <div class="example-title">
                代码
            </div>
            <div class="example-content">
				<!-- <address-form ref="addressForm"
							  v-model="formValue"></address-form> -->
			</div>
        </div>
    </div>
</template>

<script>
import addressForm from 'components/addressForm/addressForm'
export default {
    components: {
        addressForm
    },
    data() {
        return {
            formValue: {
				province: {
					name: '山西省',
					value: '140000'
				},
				city: {
                    name: '太原市',
					value: '140100'
				},
				area: {
					name: '小店区',
					value: '140105'
				},
				detail: ''
			}
        }
    },
    methods: {
        valid() {
			console.log(this.$refs.addressForm)
			let _valid = this.$refs.addressForm.validForm()
			console.log(_valid)
		}
    }
}
</script>

<style scoped lang="less">
</style>
